<template>
  <div>
    <div class="parent-box" v-if="state.username">
      <h3 class="mid-h3">请输入验证码验证身份</h3>
      <van-field
        v-model="state.pwd"
        center
        clearable
        placeholder="请输入短信验证码"
        @update:model-value="onValueChange(state.pwd)"
        :border="false"
      >
        <template #button>
          <van-button
            size="small"
            type="primary"
            color="#12CEC7"
            @click="getVerfiyCode"
            v-if="state.btnShow"
          >
            发送验证码
          </van-button>
          <van-button
            size="small"
            type="primary"
            color="#12CEC7"
            disabled
            v-else
          >
            重新获取验证码 {{ state.count }}
          </van-button>
        </template>
      </van-field>
      <van-button
        id="btn-submit"
        round
        block
        type="primary"
        color="#12CEC7"
        @click="onNext"
        :disabled="btnEnable"
      >
        下一步
      </van-button>
      <p @click="$router.back()">返回</p>
    </div>

    <!-- 密码验证注销 -->
    <div class="parent-box" v-else>
      <h3 class="mid-h3">请输入登录密码验证身份</h3>
      <van-field
        v-model="state.oldPwd"
        center
        clearable
        placeholder="请输入密码验证身份"
        @update:model-value="onValueChange(state.oldPwd)"
        :border="false"
      >
      </van-field>

      <van-button
        id="btn-submit"
        round
        block
        type="primary"
        color="#12CEC7"
        @click="onNext"
        :disabled="btnEnable"
      >
        下一步
      </van-button>
      <p @click="$router.back()">返回</p>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { yzm } from "../../api/user";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";

export default {
  name: "newspage",
  setup() {
    const btnEnable = ref(true);
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      pwd: "",
      themeVars: {
        vanFieldPlaceholderTextColor: "#000000",
      },
      username: getQueryString("username"),
      uid: getQueryString("uid"),
      btnShow: true,
      count: 60,
      oldPwd: "",
    });

    // 获取验证码
    var fetchFlag = false;
    const getVerfiyCode = () => {
      if (fetchFlag) return;
      fetchFlag = true;

      btnEnable.value = true;
      // countDown();
      yzm({
        val: getQueryString("username"),
        type: "13",
      }).then((res) => {
        fetchFlag = false;
        // console.log('账号注销获取的验证码返回的数据--------------',res);
        if (res.data.code == 1) {
          countDown();
          Toast.success("验证码已发送");
        } else {
          Toast.fail(res.data.msg);
        }
      });
    };

    const onNext = () => {
      router.push({
        path: "/newAccountCancel/AccountCancelConfirm",
        query: {
          username: state.username,
          yzm: state.pwd,
          uid: state.uid,
          oldPwd: state.oldPwd,
        },
      });
    };

    const onValueChange = (data) => {
      // 如果data的长度大于6，那么就可以点击下一步
      if (data.length > 5) {
        btnEnable.value = false;
      } else {
        btnEnable.value = true;
      }
    };

    // 触发验证码倒计时
    const countDown = () => {
      // console.log("触发了验证码倒计时--------");
      state.count = 60;
      state.btnShow = false;
      var timer = setInterval(() => {
        if (state.count < 2) {
          clearInterval(timer);
          state.btnShow = true;
        }
        state.count--;
      }, 1000);
    };

    return {
      state,
      onNext,
      btnEnable,
      getVerfiyCode,
      onValueChange,
      countDown,
    };
  },
};
</script>

<style scoped="scoped">
.parent-box {
  padding: 30px;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.parent-box ul {
  margin-top: 28px;
  margin-left: 30px;
}

.parent-box ul li {
  list-style: disc !important;
  font-weight: normal;
  color: #333;
  font-size: 28px;
}

.mid-h3 {
  color: #333;
  margin-top: 37px;
  font-size: 26px;
}

#check-box {
  margin-top: 80px;
}

.parent-box:deep(.van-field) {
  margin-top: 15px;
  /* background-color: #fff; */
  border-radius: 9px;
}

#btn-submit {
  margin-top: 60px;
}

.parent-box p {
  width: 80px;
  font-size: 34px;
  color: #9e9e9e;
  margin: 0 auto;
  margin-top: 30px;
}
</style>
